import { Selector } from '@ngxs/store';
import { LyaStateModel } from './lya.models';
import { LyaState } from './lya.state';
import {
  ConversationQuestions,
  CurrentQuestion,
  INTERVIEW_EXEC_STATE,
  LyaAutoInterviewCandidateMeta,
  QuestionsTotal,
} from './lya.types';

export class LyaSelectors {
  @Selector([LyaState])
  static members(state: LyaStateModel) {}

  @Selector([LyaState])
  static conversationMeta(state: LyaStateModel): LyaAutoInterviewCandidateMeta | null {
    return state.conversationMeta;
  }

  @Selector([LyaState])
  static generatingQuestions(state: LyaStateModel): boolean {
    return state.generatingQuestions;
  }

  @Selector([LyaState])
  static companyLogoUrl(state: LyaStateModel): string | null {
    return state.companyLogoUrl;
  }

  @Selector([LyaState])
  static conversationQuestions(state: LyaStateModel): ConversationQuestions[] {
    return state.conversationMeta?.questions ?? [];
  }

  @Selector([LyaState])
  static totalQuestions(state: LyaStateModel): number {
    return state.totalQuestions ?? 0;
  }

  @Selector([LyaState])
  static currentQuestion(state: LyaStateModel): CurrentQuestion | null {
    return state.currentQuestion;
  }

  @Selector([LyaState])
  static endInterview(state: LyaStateModel): boolean {
    return state.endInterview;
  }

  @Selector([LyaState])
  static questionsTotal(state: LyaStateModel): QuestionsTotal {
    return {
      total: state.totalQuestions ?? 0,
      responded: state.totalQuestions - (state.questionsForAsk?.length ?? 0),
    };
  }

  @Selector([LyaState])
  static transcriptionResponse(state: LyaStateModel): string {
    const current = state.currentQuestion;
    if (!current) return '';
    const index =
      state.responsesSize
        .filter((r) => r.id !== current.question.id)
        .sort((a, b) => b.size - a.size)
        .shift()?.size ?? 0;
    const response = state.currentQuestion?.response.slice(index) ?? '';
    const ignore = current.response.slice(0, index);
    return response;
    /*
    if (!state.currentQuestion) return '';
    const cutFrom = state.currentQuestion.previousResponseSize ?? 0;
    return state.currentQuestion.response?.slice(cutFrom) ?? '';*/
  }

  @Selector([LyaState])
  static interviewExecState(state: LyaStateModel): INTERVIEW_EXEC_STATE {
    const haveQuestions = (state.conversationMeta?.questions?.length ?? 0) > 0;
    const respondedQuestions = state.respondedQuestions?.length ?? 0;
    const currentQuestion = state.currentQuestion;
    const toAsk = state.questionsForAsk?.length ?? 0;
    if (!haveQuestions) {
      return 'PENDING';
    }
    if (!!currentQuestion && toAsk > 0) {
      return 'NEXT_QUESTION';
    }
    if (!!currentQuestion && toAsk === 0) {
      return 'END';
    }
    if (respondedQuestions > 0) {
      return 'CONTINUE';
    }
    return 'START';
  }
}
